import { CloudFile } from 'owa-attachment-file-types';
import { CreateSharingLinkFromFileProviderResult } from 'owa-fileprovider-link-services';
import { GetSharingInfoResponseBase } from 'owa-fileprovider-link-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { createGetODCSharingInfoResponse } from './createGetODCSharingInfoResponse';

export function createGetSharingInfoResponse(
    file: CloudFile,
    createLinkResult: CreateSharingLinkFromFileProviderResult,
    linkId: string
): GetSharingInfoResponseBase {
    switch (file.providerType) {
        case AttachmentDataProviderType.OneDriveConsumer:
            return createGetODCSharingInfoResponse(file, createLinkResult, linkId);
        default:
            throw new Error(`createGetSharingInfoResponse do not support ${file.providerType}`);
    }
}
